import { AsyncState, Updater, loadingAsyncState, unloadedAsyncState } from 'widgets-for-react'
import { slugify } from '../../../../../utils/utils'
import { Department, Centrum } from '../../../cmsPageState'
import {
  getConsultationsOverviewWaitingTimes,
  getConsultationsWaitingTimes,
  getDepartmentPage,
  getCentrumPage,
  getWaitingTimesByDepartmentOrCentrum,
} from './waitingTimesBlockApi'

export type WaitingTimesBlockState = {
  consultationsOverviewState: AsyncState<ConsultationOverview>
  consultationTimesState: AsyncState<ConsultationTimes>
  waitingTimesByDepartmentState: AsyncState<WaitingTimesByKind>
  forState: AsyncState<Department | Centrum>
}

export type WaitingTimesByKind = {
  kind: KindOfWaitingTimes
  waitingTimes: WaitingTime[]
}[]

export type WaitingTime = {
  name: string
  locations: ConsultationTimes,
}

export type ConsultationOverview = {
  department?: { title: string }
  centrum?: { title: string }
  locations: ConsultationTimes
}[]

export type ConsultationTimes = {
  location: string
  time: number
}[]

export type KindOfWaitingTimes = 'Onderzoek' | 'Behandeling' | 'Afspraaksoorten' | 'ConsultMetArts'

export type WaitingFor = {
  forPage: "centrum" | "department",
  title: string
}

export const initialWaitingTimesBlockState = (forKind?: WaitingFor): WaitingTimesBlockState => {
  if (forKind === undefined)
    return {
      forState: unloadedAsyncState(),
      consultationsOverviewState: loadingAsyncState(getConsultationsOverviewWaitingTimes),
      consultationTimesState: unloadedAsyncState(),
      waitingTimesByDepartmentState: unloadedAsyncState(),
    }
  return {
    forState: forKind.forPage == 'department' 
      ? loadingAsyncState(() => getDepartmentPage(slugify(forKind.title)))
      : loadingAsyncState(() => getCentrumPage(slugify(forKind.title))),
    consultationsOverviewState: unloadedAsyncState(),
    consultationTimesState: loadingAsyncState(() => getConsultationsWaitingTimes(forKind.forPage, forKind.title)),
    waitingTimesByDepartmentState: loadingAsyncState(() => getWaitingTimesByDepartmentOrCentrum(forKind.forPage, forKind.title)),
  }
}

export const waitingTimesBlockStateUpdaters = {
  updateDepartmentState:
    (updater: Updater<AsyncState<Department | Centrum>>) =>
    (currentState: WaitingTimesBlockState): WaitingTimesBlockState => ({
      ...currentState,
      forState: updater(currentState.forState)
    }),
  updateConsultationTimes:
    (updater: Updater<AsyncState<ConsultationTimes>>) =>
    (currentState: WaitingTimesBlockState): WaitingTimesBlockState => ({
      ...currentState,
      consultationTimesState: updater(currentState.consultationTimesState),
    }),
  updateConsultationOverview:
    (updater: Updater<AsyncState<ConsultationOverview>>) =>
    (currentState: WaitingTimesBlockState): WaitingTimesBlockState => ({
      ...currentState,
      consultationsOverviewState: updater(currentState.consultationsOverviewState),
    }),
  updateWaitingTimesByDepartment:
    (updater: Updater<AsyncState<WaitingTimesByKind>>) =>
    (currentState: WaitingTimesBlockState): WaitingTimesBlockState => ({
      ...currentState,
      waitingTimesByDepartmentState: updater(currentState.waitingTimesByDepartmentState),
    }),
}
